import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import VerifiedBadge from "../components/VerifiedBadge";
import { MessageSquare } from "lucide-react";

export default function Messages() {
  const [convs, setConvs] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/conversations").then(r => setConvs(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 py-8" data-testid="messages-inbox">
      <span className="label-eyebrow text-muted-foreground">Inbox</span>
      <h1 className="mt-2 font-display text-3xl sm:text-4xl tracking-tighter">Messages</h1>
      <p className="mt-2 text-sm text-muted-foreground">All chats are kept on EarnMate. Phone numbers, emails and external links are auto-hidden to protect both parties.</p>

      <div className="mt-8 space-y-2">
        {loading ? <p className="text-sm text-muted-foreground">Loading…</p> :
         convs.length === 0 ? (
          <div className="card-flat text-center py-12">
            <MessageSquare className="w-10 h-10 mx-auto text-brand mb-3" />
            <p className="font-display text-xl">No conversations yet</p>
            <p className="text-sm text-muted-foreground mt-1">Start a chat from a freelancer profile.</p>
            <Link to="/jobs?type=freelance" className="btn-primary mt-5 inline-flex">Browse freelance jobs</Link>
          </div>
        ) : convs.map(c => (
          <Link key={c.partner_id} to={`/messages/${c.partner_id}`} className="card-flat block flex items-center gap-3" data-testid={`conv-${c.partner_id}`}>
            {c.partner.avatar
              ? <img src={c.partner.avatar} alt="" className="w-12 h-12 rounded-full object-cover shrink-0" />
              : <div className="w-12 h-12 rounded-full bg-brand-tint text-brand grid place-items-center font-display font-black shrink-0">{(c.partner.name||"?")[0]}</div>}
            <div className="flex-1 min-w-0">
              <p className="font-medium flex items-center gap-1">{c.partner.name || "User"} {c.partner.verified && <VerifiedBadge size={12} />}</p>
              <p className="text-sm text-muted-foreground truncate">{c.last.content}</p>
            </div>
            <div className="flex flex-col items-end gap-1 shrink-0">
              <span className="text-[11px] text-muted-foreground">{new Date(c.last.created_at).toLocaleDateString()}</span>
              {c.unread > 0 && <span className="min-w-[20px] h-5 px-1.5 bg-brand text-brand-fg text-[11px] font-bold rounded-full grid place-items-center">{c.unread}</span>}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
